import { useSelector } from "react-redux";
import InputSinNumber from "../../../components/input/InputSinNumber";
import ColOpcion from "../Calculos/renglonesCostos/ColOpcion";
import ColTitulo from "../Calculos/renglonesCostos/ColTitulo";
import RowCosto from "../Calculos/renglonesCostos/RowCosto";

export default function Utilidad() {
  const {
    utilidadOpcion1,
    utilidadOpcion2,
    utilidadOpcion3,
    utilidadOpcion4,
    utilidadOpcion5,
  } = useSelector((state) => state.cotizacionesReducer.cotizacion);

  return (
    <RowCosto>
      <ColTitulo>Utilidad</ColTitulo>
      <ColOpcion>
        <InputSinNumber value={utilidadOpcion1} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={utilidadOpcion2} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={utilidadOpcion3} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={utilidadOpcion4} disabled />
      </ColOpcion>
      <ColOpcion>
        <InputSinNumber value={utilidadOpcion5} disabled />
      </ColOpcion>
    </RowCosto>
  );
}
